/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable tailwindcss/no-custom-classname */
import { useState, useMemo, useRef } from "react";
import * as Sentry from "@sentry/react";
import { createNewUser } from "../../services/user";
import { toast } from "react-toastify";
import { Button, Label, Modal, ModalBody, ModalFooter, ModalHeader, TextInput } from "flowbite-react";
import { HiPlus } from "react-icons/hi";

const AddUserModal = function (props: any) {
  const [isOpen, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const rootRef = useRef<HTMLDivElement>(null);

  const [user, setUser] = useState({
    name: "",
    email: "",
    username: "",
    password: "",
  });

  const formValid = useMemo(() => {
    return user.name && user.email && user.username && user.password;
  }, [user.name, user.email, user.username, user.password]);

  const handleChange = (e: any) => {
    const data: any = {
      ...user,
    };

    data[e.target.name] = e.target.value;

    setUser(data);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);

    try {
      const new_user = await createNewUser(user);

      if (new_user.data.error) {
        toast.error(new_user.data.message);
        Sentry.captureMessage("Error creating a new user", {
          extra: {
            payload: user,
          },
        });
      } else {
        props.getUsers();
        setOpen(false);
        toast.success("New user created successfully!");
      }
    } catch (e: any) {
      const reqMessage = e?.response?.data?.message;
      const message = Array.isArray(reqMessage)
        ? reqMessage.join(", ")
        : reqMessage;
      toast.error(`Unable to create new user: ${message || e.message}`);
      Sentry.captureMessage("Error creating a new user", {
        extra: {
          payload: user,
        },
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div ref={rootRef}>
        <Button color="primary" onClick={() => setOpen(true)}>
          <div className="flex items-center gap-x-3">
            <HiPlus className="text-xl" />
            Add user
          </div>
        </Button>
        <Modal
          onClose={() => setOpen(false)}
          show={isOpen}
          root={rootRef.current ?? undefined}
          size="3xl"
          position="top-center"
        >
          <ModalHeader className="border-b border-gray-200 p-6! dark:border-gray-700">
            <strong>Add New User</strong>
          </ModalHeader>
          <ModalBody>
            <div>
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                <div>
                  <Label htmlFor="name">Full name</Label>
                  <div className="mt-1">
                    <TextInput
                      id="name"
                      name="name"
                      placeholder="Full Name"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div>
                  <Label htmlFor="username">Username</Label>
                  <div className="mt-1">
                    <TextInput
                      id="username"
                      name="username"
                      placeholder="username"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div>
                  <Label htmlFor="email">Email</Label>
                  <div className="mt-1">
                    <TextInput
                      id="email"
                      name="email"
                      placeholder="example@company.com"
                      onChange={handleChange}
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div>
                  <Label htmlFor="password">Password</Label>
                  <div className="mt-1">
                    <TextInput
                      id="password"
                      name="password"
                      placeholder="password"
                      type="password"
                      onChange={handleChange}
                      autoComplete="new-password"
                    />
                  </div>
                </div>
              </div>
              <div
                className="my-5 w-full items-center gap-6 rounded-lg bg-blue-50 p-3 text-sm text-blue-800 dark:bg-gray-800 dark:text-blue-400"
                role="alert"
              >
                <span className="sr-only">Info</span>
                <div>
                  <svg
                    className="mr-3 inline size-4 shrink-0"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
                  </svg>{" "}
                  Users created via Admin Panel will always have a free
                  placeholder subscription, instead of a real Stripe
                  subscription.
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={handleSubmit}
              disabled={isSubmitting || !formValid}
            >
              {isSubmitting ? "Creating..." : "Create"}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default AddUserModal;
